import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import DashboardCard from "../../pages/home/common/DashboardCard";
import TrainerMember from "./TrainerMember";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";

const ReportCards = ({ stats, prevAllFilters }) => {
  const { trainerReportsStatsLoading } = useSelector((state) => state.api);

  const initialClickValues = {
    isModOpen: false,
    cardName: "",
    cardValue: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onClickCard = (cardName, cardValue) => {
    setClickValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardName: cardName,
      cardValue: cardValue,
    }));
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Trainer Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer minWidth80vw">
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/_/g, " ")} - ${
              clickValues.cardValue
            }`}
            onClose={onCloseModal}
          />

          <TrainerMember
            cardName={clickValues.cardName}
            prevAllFilters={prevAllFilters}
          />
        </div>
      </Modal>

      {trainerReportsStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-container cards-grid-container grid-4 mt-2rem">
          <DashboardCard
            tagName={"members"}
            cardLabel={"Total Members"}
            value={stats?.total_members ? stats.total_members : 0}
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"Assigned Members With Trainer"}
            value={
              stats?.total_assigned_members ? stats.total_assigned_members : 0
            }
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"Not Assigned Members"}
            value={
              stats?.total_not_assigned_members
                ? stats.total_not_assigned_members
                : 0
            }
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"Biomax Registered Members"}
            value={
              stats?.total_biomax_registered ? stats.total_biomax_registered : 0
            }
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"Biomax Not Registered Members"}
            value={
              stats?.total_biomax_not_registered
                ? stats.total_biomax_not_registered
                : 0
            }
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"PT Trial Pending"}
            value={
              stats?.total_pending_pt_trial ? stats.total_pending_pt_trial : 0
            }
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"PT Trial Completed"}
            value={
              stats?.total_completed_pt_trial
                ? stats.total_completed_pt_trial
                : 0
            }
            onClickCard={onClickCard}
          />
        </div>
      )}
    </>
  );
};

export default ReportCards;
